import { render } from "./AppPhone.vue?vue&type=template&id=64dd929b&lang=pug"
import script from "./AppPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPhone.vue?vue&type=script&setup=true&lang=js"

import "./AppPhone.vue?vue&type=style&index=0&id=64dd929b&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__